export default __webpack_public_path__ + "static/media/phone.30da13c9.svg";